import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { API, Auth } from "aws-amplify";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import {
  reinstallments,
  calcuratorInterestTwo,
} from "../../utils/reinstallments";
import { calReportAging } from "../../utils/calReportAging";
import { pad } from "utils/getLocalDateTime";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ReportLoanRequest({ selectToday }) {
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [dataReport, setDataReport] = useState([]);
  const [isClick, setIsClick] = useState(false);

  useEffect(() => {
    if (isClick) {
      const getExportId = document.getElementById(
        "export-excel-report-loan-request"
      );
      getExportId.click();
    }
  }, [isClick, dataReport]);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickReportLoanRequest = async () => {
    try {
      setLoading(true);

      const data = await API.get(
        "MoneyHubAdmin",
        "/loanRequest/reportLoanRequest",
        {
          queryStringParameters: {
            today: selectToday,
            //   ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      setDataReport(data.items);
      setIsClick(true);
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
    }
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // border: borderColumn,
  };

  const getDistrict = (address) => {
    if (address) {
      const district = address.split(",")[1];
      return district;
    }
    return "";
  };

  const getProvince = (address) => {
    if (address) {
      const province = address.split(",")[2];
      return province;
    }
    return "";
  };

  const getDateOfWeek = (reportCreated) => {
    const dayReportCreated = new Date(reportCreated).getDay();
    const weekday = [
      "อาทิตย์",
      "จันทร์",
      "อังคาร",
      "พุธ",
      "พฤหัสบดี",
      "ศุกร์",
      "เสาร์",
    ];
    return weekday[dayReportCreated];
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    var filled = { fgColor: { rgb: "FFFFFF" } };
    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      const dataReport = data[i];

      result.push([
        {
          value: dataReport.phone_number || "",
          style,
        },
        {
          value: dataReport.loan_kbank_id || "",
          style,
        },
        {
          value: dataReport.name + " " + dataReport.lastname || "",
          style,
        },
        {
          value: dataReport.requestamount || "",
          style,
        },
        {
          value: dataReport.amount || "",
          style,
        },
        {
          value: dataReport.purpose || "",
          style,
        },
        {
          value: format(new Date(dataReport.reportCreated), "dd-MM-yyyy") || "",
          style,
        },
        {
          value: dataReport.loan_status || "",
          style,
        },
        {
          value: dataReport.gender || "",
          style,
        },
        {
          value: dataReport.age || "",
          style,
        },
        {
          value: dataReport.marritalStatus || "",
          style,
        },
        {
          value: getDistrict(dataReport.currentAddress) || "",
          style,
        },
        {
          value: getProvince(dataReport.currentAddress) || "",
          style,
        },
        {
          value: getDistrict(dataReport.address) || "",
          style,
        },
        {
          value: getProvince(dataReport.address) || "",
          style,
        },
        {
          value: dataReport.education || "",
          style,
        },
        {
          value: dataReport.careertype || "",
          style,
        },
        {
          value: dataReport.income || "",
          style,
        },
        {
          value: dataReport.burden || "",
          style,
        },
        {
          value: dataReport.burdenSum || "",
          style,
        },
        {
          value: getDateOfWeek(dataReport.reportCreated) || "",
          style,
        },
        {
          value: format(new Date(dataReport.timestamp), "dd-MM-yyyy HH:mm"),
          style,
        },
      ]);
    }

    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "เบอร์โทร",
          width: { wch: 26 },
          style,
        },
        {
          title: "Job no",
          width: { wch: 26 },
          style,
        },
        {
          title: "ชื่อ",
          width: { wch: 38 },
          style,
        },
        {
          title: "วงเงินที่ได้",
          width: { wch: 24 },
          style,
        },
        {
          title: "วงเงินที่ขอ",
          width: { wch: 24 },
          style,
        },
        {
          title: "ประเภทสินเชื่อ",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 24 },
          style,
        },
        {
          title: "สถานะ",
          width: { wch: 24 },
          style,
        },
        {
          title: "เพศ",
          width: { wch: 24 },
          style,
        },
        {
          title: "อายุ",
          width: { wch: 24 },
          style,
        },
        {
          title: "สถานภาพ",
          width: { wch: 24 },
          style,
        },
        {
          title: "ที่อยู่ปัจจุบัน เขต/อำเภอ",
          width: { wch: 24 },
          style,
        },
        {
          title: "ที่อยู่ปัจจุบัน จังหวัด",
          width: { wch: 24 },
          style,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน เขต/อำเภอ",
          width: { wch: 24 },
          style,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน จังหวัด",
          width: { wch: 24 },
          style,
        },
        {
          title: "การศึกษา",
          width: { wch: 24 },
          style,
        },
        {
          title: "อาชีพปัจจุบัน",
          width: { wch: 24 },
          style,
        },
        {
          title: "รายได้",
          width: { wch: 24 },
          style,
        },
        {
          title: "รายจ่าย",
          width: { wch: 24 },
          style,
        },
        {
          title: "ภาระหนี้สิน",
          width: { wch: 24 },
          style,
        },
        {
          title: "จันทร์ - อาทิตย์",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่กู้",
          width: { wch: 24 },
          style,
        },
      ],
      data: createDataWithStyle(dataReport),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`REPORT_LOAN_REQUEST_${format(
          new Date(selectToday),
          "yyyy-MM-dd"
        )}`}
        element={<button id="export-excel-report-loan-request" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSet}
          name="Report Loan Request"
        ></ExcelSheet>
      </ExcelFile>
      <button
        disabled={loading}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
        onClick={onClickReportLoanRequest}
      >
        {loading && (
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx={12}
              cy={12}
              r={10}
              stroke="currentColor"
              strokeWidth={4}
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
        </svg>
        {count > 0 && `(${count})`} Report LoanRequest
      </button>
    </div>
  );
}

export default ReportLoanRequest;
